import { Link } from "Navigation/Link";
import type { MouseEventHandler } from "react";
import { appUrl } from "Utils/UrlUtils";

type Props = {
  name?: string | null;
  publicID?: string | null;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
};

/** Merchant name linking to the admin detail; plain text when the piece carries only the name. */
export const MerchantLink = ({ name, publicID, onClick }: Props) => {
  if (!name) {
    return null;
  }

  if (!publicID) {
    return name;
  }

  return (
    <Link to={`${appUrl("merchant-detail")}/${publicID}`} onClick={onClick}>
      {name}
    </Link>
  );
};
